import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(() => ({
  page: {
    padding: '16px 24px',
  },
  contentGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '16px 0',
  },
  statusButtons: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
  },
  tableContainer: {
    flex: 1,
    margin: '20px 2% 20px 34px',
  },
  mainTable: {
    width: 'auto',
    height: '616px',
  },
  modalContent: {
    alignItems: 'stretch',
    gap: '20px',
    padding: '24px 32px 28px',
  },
  modalForm: {
    display: 'grid',
    gap: '24px',
    gridTemplateColumns: '1fr 1fr',
  },
  modalActions: {
    justifyContent: 'flex-end',
  },
  qrCodeContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px 40px 36px',
    gap: '12px',
    width: '100%',
    boxSizing: 'border-box',
  },
  qrCodeHint: {
    fontSize: '14px',
    color: Theme.Colors.Grayscale.SixtyFour,
    textAlign: 'center',
    marginBottom: '4px',
  },
  qrCodeError: {
    fontSize: '14px',
    color: Theme.Colors.Red.Base,
    textAlign: 'center',
    marginTop: '4px',
  },
  qrCodeImageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  qrCodeImage: {
    width: '280px',
    height: '280px',
    objectFit: 'contain',
    display: 'block',
  },
  modalDivider: {
    backgroundColor: Theme.Colors.Grayscale.Twelve,
    marginBottom: '16px',
  },
  statusPill: {
    fontSize: '11px',
    fontWeight: 600,
    padding: '4px 10px',
    borderRadius: '999px',
    width: 'fit-content',
  },
  statusPillActive: {
    color: Theme.Colors.Green.Base,
    background: Theme.Colors.Green.Lightest,
    border: `1px solid ${Theme.Colors.Green.Base}`,
  },
  statusPillDisconnected: {
    color: Theme.Colors.Red.Base,
    background: Theme.Colors.Red.Lightest,
    border: `1px solid ${Theme.Colors.Red.Base}`,
  },
  statusPillWaiting: {
    color: Theme.Colors.Yellow.Base,
    background: Theme.Colors.Yellow.Lightest,
    border: `1px solid ${Theme.Colors.Yellow.Base}`,
  },
  listCellLink: {
    color: Theme.Colors.Primary.Base,
    fontWeight: 600,
  },
}))

export const datagridStyle = {
  fontSize: Theme.Typography.FontSize.XXSmall,
  '& .MuiDataGrid-cell:hover': {
    cursor: 'pointer',
  },
}
